import { Box, Button, Stack } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { RHFRadioGroup } from "../../hook-form/RHFRadioGroup";
import { RHFTextField } from "../../hook-form/RHFTextField";
import { RHFDatePicker } from "../../hook-form/RHFDateSelect";
import { RHFCheckbox } from "../../hook-form/RHFCheckbox";
import { PottingPostPayload } from "../../../types/PottingTypes";
import { postPotting } from "../../../services/PottingService";

type Props = {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  defaultComponent?: "A" | "B";
};

export function PottingForm({ onSuccess, onError, defaultComponent }: Props) {
  const methods = useForm<{
    pottingBatch: string;
    component: string;
    isgoodentrance: boolean;
  }>({
    defaultValues: {
      pottingBatch: "",
      component: defaultComponent ?? "",
      isgoodentrance: false,
    },
  });

  const { control, handleSubmit, reset } = methods;

  const onSubmit = async (data: {
    pottingBatch: string;
    component: string;
    isgoodentrance: boolean;
  }) => {
    const payload: PottingPostPayload = {
      stationid: 40,
      manufacturingDate: new Date().toISOString(),
      pottingBatch: data.pottingBatch,
      component: data.component,
      isGoodEntrance: data.isgoodentrance,
    };

    try {
      await postPotting(payload);
      reset();
      onSuccess?.();
    } catch (err: any) {
      if (err.code === "ERR_CANCELED" || err.name === "CanceledError") {
        console.debug("Potting request was canceled");
        return;
      }

      onError?.(err?.message || "Fehler beim Speichern");
    }
  };

  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <RHFTextField
            name="pottingBatch"
            label="Batch Nr."
            control={control}
            required
          />
          <RHFDatePicker
            name="manufacturingDate"
            label="Produktionsdatum der Komponente"
            control={control}
          />
          <RHFCheckbox
            name="isgoodentrance"
            label="Wareneingang"
            control={control}
          />
          <RHFRadioGroup
            name="component"
            label="A- oder B-Komponente"
            control={control}
            required
            options={[
              { label: "A-Komponente", value: "A" },
              { label: "B-Komponente", value: "B" },
            ]}
          />
          <Button type="submit" variant="contained" color="primary">
            Speichern
          </Button>
        </Stack>
      </Box>
    </FormProvider>
  );
}
